{
  "actions": "Дії",
  "actionsAvailable": "Доступні дії.",
  "clearSelection": "Очистити вибір",
  "selected": "Вибрано: {count}",
  "selectedAll": "Усе вибрано"
}
